export default __webpack_public_path__ + "static/media/0353.b0865dd6.jpg";